<script>
  import { fly } from 'svelte/transition';
  import Spinner from './Spinner.svelte';
  import SplashLogo from './SplashLogo.svelte';
  import { delay } from '~/animations/utils.svelte';
</script>

<div class="container">
  <SplashLogo animate />
  {#await delay(250) then}
    <div in:fly={{ y: 100 }} class="loading-dictionary">
      Loading...
      <br />
      <Spinner />
    </div>
  {/await}
</div>

<style lang="scss">
  @use '~/theme/include-media' as *;
  .container {
    margin: auto;
    grid-template-rows: 1/2;
    grid-template-columns: 1/2;
  }
  .loading-dictionary {
    margin-top: 8em;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 1.75rem;
  }
</style>
